import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { getChildLeaves } from "../../api/parentDashboardApi";

const statusSeverity = {
  approved: "success",
  pending: "warning",
  rejected: "danger",
};

const ChildLeavesTab = ({ child }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!child?.id) return;
    const load = async () => {
      try {
        setLoading(true);
        const data = await getChildLeaves(child.id);
        if (data?.success) setItems(data.items || []);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [child?.id]);

  return (
    <DataTable value={items} loading={loading} paginator rows={10} stripedRows emptyMessage="No leave records.">
      <Column field="reason" header="Reason" />
      <Column
        field="startDate"
        header="From"
        body={(row) => (row.startDate ? new Date(row.startDate).toLocaleDateString() : "—")}
      />
      <Column
        field="endDate"
        header="To"
        body={(row) => (row.endDate ? new Date(row.endDate).toLocaleDateString() : "—")}
      />
      <Column
        field="status"
        header="Status"
        body={(row) => <Tag value={row.status} severity={statusSeverity[row.status] || "info"} />}
      />
    </DataTable>
  );
};

export default ChildLeavesTab;
